import styled from 'styled-components';

export default styled.div`
  grid-area: button;
  display: grid;
  align-content: center;
`;
